module.exports = "<div class=\"spinner\"></div>\n"